import React, { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import {Button, Divider} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Green from './img/sustainable.jpg';
import Illus from './img/illus.jpg';
import Burn from './img/burn.jpg';
import Burner from './img/slider/charity.jpg';
import Bg from './img/pellets_1.jpg';
import Energy from './img/energy.jpg';
import form1 from './3AM_FORMS.pdf';
import form2 from './3AM_Liability.pdf';
import Para0 from './img/slider/image1.jpg';
import Para1 from './img/slider/image.jpg';
import Countdown from './count';
import Pic1 from './img/trip/2022.jpg';
import Pic2 from './img/trip/give1.jpg';
import Pic3 from './img/trip/ethio4.jpg';
import Pic4 from './img/trip/give3.jpg';
import Pic5 from './img/trip/kenya.jpg';
import Pic6 from './img/trip/2022_0.jpg';
import Pic9 from './img/FB_IMG_1689787670548.jpg';
import Pict from './img/trip/tanzania.jpeg';
import Para3 from './img/slide3.jpeg';
import UserImage from './img/image.jpg';
import Grid from '@material-ui/core/Grid';
import { Parallax } from "react-parallax";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import ImageListItemBar from '@material-ui/core/ImageListItemBar';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import itemData from './data';
import Typography from '@material-ui/core/Typography';
import Vid from './videos/churchbuilding.mp4';
import Vid2 from './videos/Schoolbuilding.mp4';
import Vid1 from './videos/tanzania.mp4';
import imager from './img/outreach.png';
import Community from './img/slider/community.svg';
import Evangelism from './img/slider/evengelism.svg';
import Medical from './img/slider/medical.svg';
import AOS from 'aos';
import "aos/dist/aos.css";
import Carousel_ from 'react-grid-carousel'

import ButtonBase from '@material-ui/core/ButtonBase';
import  {
  Link
} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  // Hero Section Styles
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: `linear-gradient(135deg, rgba(97, 218, 251, 0.8) 0%, rgba(74, 144, 226, 0.8) 50%, rgba(44, 62, 80, 0.9) 100%), url(${UserImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(44, 62, 80, 0.6)',
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: 'white',
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3rem',
    fontWeight: 700,
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8rem',
      lineHeight: 1.2,
    },
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    fontWeight: 300,
    marginBottom: '2rem',
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.1rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      lineHeight: 1.4,
    },
  },
  heroButton: {
    background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
    border: 0,
    borderRadius: 25,
    boxShadow: '0 3px 5px 2px rgba(97, 218, 251, .3)',
    color: '#2C3E50',
    height: 48,
    padding: '0 30px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 10px 2px rgba(97, 218, 251, .4)',
    },
  },

  // Section Styles
  section: {
    padding: '80px 0',
    [theme.breakpoints.down('md')]: {
      padding: '60px 0',
    },
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
    position: 'relative',
    '&::after': {
      content: '""',
    position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '60px',
      height: '4px',
      background: 'linear-gradient(45deg, #61DAFB, #FFD700)',
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },

  // Card Styles
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9 aspect ratio
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardContent: {
    flexGrow: 1,
    padding: '24px',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: '#2c3e50',
  },
  cardText: {
    color: '#7f8c8d',
    lineHeight: 1.6,
  },

  // Project Section
  projectSection: {
    background: 'linear-gradient(135deg, #E8F4FD 0%, #D1E9FB 100%)',
    padding: '80px 0',
  },
  projectCard: {
    background: 'white',
    borderRadius: 16,
    padding: '30px',
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.15)',
    transition: 'all 0.3s ease',
    height: '100%',
    border: '1px solid rgba(97, 218, 251, 0.1)',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 16px 48px rgba(97, 218, 251, 0.25)',
      border: '1px solid rgba(97, 218, 251, 0.3)',
    },
  },
  projectTitle: {
    fontSize: '1.8rem',
    fontWeight: 600,
    color: '#2c3e50',
    marginBottom: '1.5rem',
  },
  projectList: {
    color: '#34495e',
    lineHeight: 1.8,
    '& li': {
      marginBottom: '1rem',
      paddingLeft: '1rem',
    },
  },

  // Donate Button
  donateButton: {
    background: 'linear-gradient(45deg, #61DAFB 30%, #FFD700 90%)',
    borderRadius: 16,
    padding: '20px',
    textAlign: 'center',
    color: '#2C3E50',
    textDecoration: 'none',
    display: 'block',
    transition: 'all 0.3s ease',
    fontWeight: 600,
    '&:hover': {
      transform: 'scale(1.02)',
      textDecoration: 'none',
      color: '#2C3E50',
      boxShadow: '0 8px 32px rgba(97, 218, 251, 0.4)',
    },
  },
  donateText: {
    fontSize: '2rem',
    fontWeight: 700,
    margin: 0,
  },

  // Gallery Section
  gallerySection: {
    background: 'linear-gradient(135deg, #F8FBFF 0%, #E8F4FD 100%)',
    padding: '80px 0',
  },
  galleryTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: '#2c3e50',
  },

  // Video Section
  videoSection: {
    padding: '80px 0',
    background: 'white',
  },
  videoCard: {
    background: 'white',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 16px 48px rgba(0,0,0,0.15)',
    },
  },
  videoTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    color: '#2c3e50',
    textAlign: 'center',
    padding: '20px',
    margin: 0,
  },

  // Services Section
  servicesSection: {
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    padding: '80px 0',
    color: 'white',
  },
  serviceCard: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: 16,
    padding: '30px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
    height: '100%',
    border: '1px solid rgba(255,255,255,0.2)',
    '&:hover': {
      transform: 'translateY(-8px)',
      background: 'rgba(255,255,255,0.15)',
      border: '1px solid rgba(255, 215, 0, 0.3)',
    },
  },
  serviceIcon: {
    width: '80px',
    height: '80px',
    margin: '0 auto 20px',
    // filter: 'brightness(0) invert(1)',
  },
  serviceTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: 'white',
  },
  serviceText: {
    color: 'rgba(255,255,255,0.9)',
    lineHeight: 1.6,
  },

  // Map Section
  mapSection: {
    padding: '60px 0',
    background: 'linear-gradient(135deg, #E8F4FD 0%, #D1E9FB 100%)',
  },
  mapContainer: {
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(97, 218, 251, 0.15)',
    border: '1px solid rgba(97, 218, 251, 0.1)',
  },

  // Responsive adjustments
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
  },

  // Countdown Timer Styles
  countdownSection: {
    padding: '80px 0',
    background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)',
    color: 'white',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
    position: 'absolute',
      top: 0,
    left: 0,
    right: 0,
    bottom: 0,
      background: 'url(' + UserImage + ')',
    backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.1,
      zIndex: 0,
    },
  },
  countdownContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
  },
  countdownTitle: {
    fontSize: '3rem',
    fontWeight: 700,
    marginBottom: '1rem',
    color: '#FFD700',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  countdownSubtitle: {
    fontSize: '1.2rem',
    fontWeight: 300,
    marginBottom: '3rem',
    color: 'rgba(255,255,255,0.9)',
  },
  countdownGrid: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '2rem',
    [theme.breakpoints.down('sm')]: {
      gap: '8px',
    },
  },
  countdownItem: {
    background: 'rgba(255,255,255,0.1)',
    borderRadius: 12,
    padding: '15px 10px',
    minWidth: '80px',
    textAlign: 'center',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255,255,255,0.2)',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      minWidth: '70px',
      padding: '12px 8px',
      borderRadius: 8,
    },
    '&:hover': {
      transform: 'translateY(-5px)',
      background: 'rgba(255,255,255,0.15)',
      border: '1px solid rgba(255, 215, 0, 0.3)',
    },
  },
  countdownNumber: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#FFD700',
    marginBottom: '5px',
    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  countdownLabel: {
    fontSize: '0.8rem',
    fontWeight: 500,
    color: 'rgba(255,255,255,0.8)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
    },
  },

  // Advertising Section Styles
  advertisingSection: {
    padding: '80px 0',
    background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
    position: 'relative',
    overflow: 'hidden',
  },
  advertisingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      textAlign: 'center',
      gap: '30px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '20px',
    },
  },
  advertisingImage: {
    flex: '0 0 400px',
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    border: '3px solid rgba(255,255,255,0.2)',
    [theme.breakpoints.down('md')]: {
      flex: '0 0 auto',
    width: '100%',
      maxWidth: '400px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '300px',
      borderRadius: 15,
    },
  },
  advertisingContent: {
    flex: 1,
    color: 'white',
  },
  advertisingTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    color: '#FFD700',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  advertisingText: {
    fontSize: '1.1rem',
    lineHeight: 1.8,
    marginBottom: '2rem',
    color: 'rgba(255,255,255,0.9)',
  },
  advertisingButton: {
    background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
    border: 0,
    borderRadius: 25,
    boxShadow: '0 6px 20px rgba(255, 215, 0, 0.3)',
    color: '#2C3E50',
    height: 50,
    padding: '0 30px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
    },
  },
}));

// Countdown Timer Component
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('May 12, 2026 00:00:00').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Use inline styles instead of useStyles to avoid theme issues
  const countdownStyles = {
    countdownGrid: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      flexWrap: 'wrap',
      marginBottom: '2rem',
    },
    countdownItem: {
      background: 'rgba(255,255,255,0.1)',
      borderRadius: 12,
      padding: '15px 10px',
      minWidth: '80px',
      textAlign: 'center',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255,255,255,0.2)',
      transition: 'all 0.3s ease',
    },
    countdownNumber: {
      fontSize: '2rem',
      fontWeight: 700,
      color: '#FFD700',
      marginBottom: '5px',
      textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    },
    countdownLabel: {
      fontSize: '0.8rem',
      fontWeight: 500,
      color: 'rgba(255,255,255,0.8)',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
  };

  return (
    <div>
      <div style={countdownStyles.countdownGrid} data-aos="fade-up" data-aos-delay="100">
        <div style={countdownStyles.countdownItem}>
          <div style={countdownStyles.countdownNumber}>{timeLeft.days}</div>
          <div style={countdownStyles.countdownLabel}>Days</div>
        </div>
        <div style={countdownStyles.countdownItem}>
          <div style={countdownStyles.countdownNumber}>{timeLeft.hours}</div>
          <div style={countdownStyles.countdownLabel}>Hours</div>
        </div>
        <div style={countdownStyles.countdownItem}>
          <div style={countdownStyles.countdownNumber}>{timeLeft.minutes}</div>
          <div style={countdownStyles.countdownLabel}>Minutes</div>
        </div>
        <div style={countdownStyles.countdownItem}>
          <div style={countdownStyles.countdownNumber}>{timeLeft.seconds}</div>
          <div style={countdownStyles.countdownLabel}>Seconds</div>
        </div>
      </div>

{/* 
      <Typography variant="body1" style={{color: 'rgba(255,255,255,0.9)', marginBottom: '2rem', textAlign: 'center', maxWidth: '100%'}} data-aos="fade-up">
        Download the registration and liability forms below. Fill them out and send them to us to secure your spot.
      </Typography>

      <div style={{
        display: 'flex', 
        gap: '10px', 
        flexWrap: 'wrap', 
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
                  <Button 
            variant="contained" 
            style={{
              background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
              border: 0,
              borderRadius: 25,
              boxShadow: '0 6px 20px rgba(255, 215, 0, 0.3)',
              color: '#2C3E50',
              height: 50,
              padding: '0 20px',
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              transition: 'all 0.3s ease',
              minWidth: '200px',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
              },
            }}
          // data-aos="fade-up"
          onClick={() => {
            try {
              const link = document.createElement('a');
              link.href = form1;
              link.download = '3AM_Registration_Form.pdf';
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error('Download failed:', error);
              // Fallback: open in new tab
              window.open(form1, '_blank');
            }
          }}
        >
          📄 Download Registration Form
        </Button>
        <Button 
          variant="outlined" 
          style={{
            marginBottom: '60px',
            border: '2px solid #FFD700',
            color: '#FFD700',
            borderRadius: 25,
            height: 50,
            padding: '0 20px',
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            transition: 'all 0.3s ease',
            minWidth: '200px',
            '&:hover': {
              background: '#FFD700',
              color: '#2C3E50',
              border: '2px solid #FFD700',
              transform: 'translateY(-2px)',
            },
          }}
          // data-aos="fade-up"
          onClick={() => {
            try {
              const link = document.createElement('a');
              link.href = form2;
              link.download = '3AM_Liability_Form.pdf';
              link.target = '_blank';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error('Download failed:', error);
              // Fallback: open in new tab
              window.open(form2, '_blank');
            }
          }}
        >
          📋 Download Liability Form
        </Button>
      </div> */}
    </div>
  );
};

// Advertising Section Component
const AdvertisingSection = () => {
  const classes = useStyles();

  return (
    <section className={classes.advertisingSection}>
      <div className={classes.container}>
        <div className={classes.advertisingContainer}>
          <div className={classes.advertisingContent} data-aos="fade-left">
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: 16,
              padding: '30px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)',
            }}>
              <Typography variant="h2" className={classes.advertisingTitle}>
                Join Our Mission
              </Typography>
              <Typography variant="body1" className={classes.advertisingText}>
                Be part of something bigger than yourself. Our mission is to spread the Three Angels' Message 
                to every corner of the world. Whether through evangelism, community outreach, or humanitarian 
                aid, your involvement can make a lasting impact on countless lives.
              </Typography>
              <Typography variant="body1" className={classes.advertisingText}>
                We're looking for passionate individuals who are ready to serve, learn, and grow in their 
                faith while making a difference in communities around the globe.
              </Typography>
              
              <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '2rem'}}>
                {/* <Button 
                  variant="contained" 
                  className={classes.advertisingButton}
                  component={Link}
                  to="/aboutus"
                  style={{
                    background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
                    boxShadow: '0 6px 20px rgba(255, 215, 0, 0.3)',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px rgba(255, 215, 0, 0.4)',
                    },
                  }}
                >
                  Learn More
                </Button>
                <Button 
                  variant="outlined" 
                  style={{
                    border: '2px solid #FFD700',
                    color: '#FFD700',
                    borderRadius: 25,
                    height: 50,
                    padding: '0 30px',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: '#FFD700',
                      color: '#2C3E50',
                      border: '2px solid #FFD700',
                      transform: 'translateY(-2px)',
                    },
                  }}
                  component={Link}
                  to="/contactus"
                >
                  Get Involved
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Caroo = () => {
  return (
    <Carousel_ cols={3} rows={1} gap={20} autoplay={4000} loop>
      <Carousel_.Item>
        <img width="100%" src={Pict} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}/>
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Community Outreach In Tanzania (2024)</b>
        </p>
      </Carousel_.Item>
      <Carousel_.Item>
        <img width="100%" src={Pic1} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}}/>
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Evangelism In Madagascar</b>
        </p>
      </Carousel_.Item>
      <Carousel_.Item>
        <img width="100%" src={Pic2} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}} />
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Community Outreach In Ghana</b>
        </p>
      </Carousel_.Item>
      <Carousel_.Item>
        <img width="100%" src={Pic3} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}} />
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Evangelism in Ethiopia</b>
        </p>
      </Carousel_.Item> 
      <Carousel_.Item>
        <img width="100%" src={Pic4} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}} />
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Community Outreach In India</b>
        </p>
      </Carousel_.Item>  
      <Carousel_.Item>
        <img width="100%" src={Pic5} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}} />
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Community Outreach In Kenya</b>
        </p>
      </Carousel_.Item> 
      <Carousel_.Item>
        <img width="100%" src={Pic6} style={{borderRadius: 12, boxShadow: '0 4px 20px rgba(0,0,0,0.1)'}} />
        <br/>
        <p style={{margin: '10px 0 0 0', fontSize: '1rem', fontWeight: 500}}>
          <b>Evangelism In Madagascar</b>
        </p>
      </Carousel_.Item>
    </Carousel_>
  );
};

const Caro2 = () => {
  return (
    <Carousel_ cols={1} rows={1} gap={20} loop>
      
      
       <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            Church Building Project
          </p>
          <video src={Vid} controls width="100%" style={{borderRadius: 12}} />
        </div>
      </Carousel_.Item>

       <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            School Building Project
          </p>
          <video width="100%" src={Vid2} controls style={{borderRadius: 12}} />
        </div>
      </Carousel_.Item>
      
      <Carousel_.Item>
        <div style={{background: 'white', borderRadius: 16, padding: '20px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)'}}>
          <p style={{margin: '0 0 20px 0', fontSize: '1.5rem', textAlign: 'center', fontWeight: 600, color: '#2c3e50'}}>
            Mission Tanzania 2024
          </p>
          <iframe 
            src="https://drive.google.com/file/d/1Zs7cQGIh8g5b5V5k6XOLx2mSwn71zXzH/preview" 
            width="100%" 
            height="400" 
            style={{borderRadius: 12, border: 'none'}} 
            allow="autoplay"
          />
        </div>
      </Carousel_.Item>
      
    </Carousel_>
  );
};

function Example(props) {
    AOS.init({
    duration: 800,
    once: true,
    offset: 100
  });
  
    const classes = useStyles();
    
    var items = [
        {
      name: <h1 style={{color:"white", fontSize:"3.5rem", marginTop:80, fontWeight: 700}} data-aos={"fade-up"}>
        <span style={{ paddingLeft:12, paddingRight:12,  textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>
          -3<span style={{color:'#FFD700', textShadow: '2px 2px 4px rgba(255, 215, 0, 0.3)'}}>AM</span> Mission Ministry-
        </span>
      </h1>,
            image: Pic9,
            description: "Welcome to"
        },  
        {
      name: <h1 style={{color:"white", fontSize:"3.5rem", marginTop:30, fontWeight: 700}} data-aos={"fade-up"}>
        <span style={{ paddingLeft: 12, paddingRight: 12, backgroundColor: "rgba(44, 62, 80, 0.8)", borderRadius: 8, textShadow: '2px 2px 4px rgba(0,0,0,0.5)', border: '2px solid rgba(97, 218, 251, 0.3)'}}>
          Let's Reach Out To The World
        </span>
      </h1>,
          image: Pic9,
          description: ""
        },
  ];

    return (
        <div>
      {/* Hero Section with Countdown */}
      <section className={classes.heroSection}>
        <div className={classes.heroOverlay}></div>
        <div className={classes.heroContent}>
          <Typography variant="h1" style={{marginTop: "100px"}} className={classes.heroTitle} data-aos="fade-up">
            <span style={{ paddingLeft: 12, paddingTop: "100px", paddingRight: 12, textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>
              -3<span style={{color:'#FFD700', textShadow: '2px 2px 4px rgba(255, 215, 0, 0.3)'}}>AM</span> Mission Ministry-
            </span>
          </Typography>
          <Typography variant="h4" className={classes.heroSubtitle} data-aos="fade-up" data-aos-delay="200">
            Let's Reach Out To The World
          </Typography>
        </div>
      </section>

      {/* Advertising Section */}
      <AdvertisingSection />

      {/* Projects Section */}
      <section className={classes.projectSection}>
        <div className={classes.container}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}} data-aos="fade-up">
            <Typography variant="h2" className={classes.sectionTitle}>
              Our Current Projects
            </Typography>
            <Typography variant="h5" style={{color: '#7f8c8d', fontWeight: 300, marginTop: '1rem'}}>
              Building communities and spreading hope worldwide
            </Typography>
          </div>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="100">
              <div style={{
                background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
                borderRadius: 20,
                padding: '40px',
                height: '100%',
                color: 'white',
                boxShadow: '0 20px 40px rgba(97, 218, 251, 0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                position: 'relative',
                overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute',
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '50%',
                  zIndex: 0,
                }}></div>
                <div style={{position: 'relative', zIndex: 1}}>
                  <Typography variant="h4" style={{fontWeight: 700, marginBottom: '2rem', color: '#FFD700'}}>
                    🏗️ Project Description
                  </Typography>
                  <ol style={{
                    listStyle: 'none',
                    padding: 0,
                    counterReset: 'project-counter',
                  }}>
                    <li style={{
                      counterIncrement: 'project-counter',
                      marginBottom: '1.5rem',
                      padding: '20px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: 12,
                      borderLeft: '4px solid #FFD700',
                      position: 'relative',
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        left: '-10px',
                        background: '#FFD700',
                        color: '#2C3E50',
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 700,
                      }}>
                        {String.fromCharCode(65 + 0)}
                      </div>
                      <div style={{marginLeft: '20px'}}>
                        We are building 3 additional classrooms, an office for principal, desks and benches, improve toilets and add an overhead water tank to collect rain water for daily use at SDA Elementary School in the district of Infanadiana in Madagascar
                      </div>
                    </li>
                    <li style={{
                      counterIncrement: 'project-counter',
                      marginBottom: '1.5rem',
                      padding: '20px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: 12,
                      borderLeft: '4px solid #FFD700',
                      position: 'relative',
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '20px',
                        left: '-10px',
                        background: '#FFD700',
                        color: '#2C3E50',
                        borderRadius: '50%',
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 700,
                      }}>
                        {String.fromCharCode(65 + 1)}
                      </div>
                      <div style={{marginLeft: '20px'}}>
                        We are building a new church for the SDA church at Antadinambo in Madagascar which has a little building to accommodate church members.
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="200">
              <Link to="/donate" style={{textDecoration: 'none', display: 'block', height: '100%'}}>
                <div style={{
                  background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
                  borderRadius: 20,
                  padding: '40px',
                  height: '100%',
                  color: '#2C3E50',
                  boxShadow: '0 20px 40px rgba(255, 215, 0, 0.3)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-10px)';
                  e.target.style.boxShadow = '0 30px 60px rgba(255, 215, 0, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 20px 40px rgba(255, 215, 0, 0.3)';
                }}>
                  <div style={{
                    fontSize: '4rem',
                    marginBottom: '1rem',
                  }}>
                    💝
                  </div>
                  <Typography variant="h3" style={{fontWeight: 700, marginBottom: '1rem'}}>
                    Donate Here
            </Typography>
                  <Typography variant="body1" style={{marginBottom: '2rem', opacity: 0.8}}>
                    Support our mission and make a difference
                  </Typography>
                  <div style={{
                    background: 'rgba(255,255,255,0.2)',
                    borderRadius: 25,
                    padding: '12px 30px',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    border: '2px solid rgba(255,255,255,0.3)',
                  }}>
                    Click to Donate
                  </div>
                </div>
</Link>            
         </Grid>
        </Grid>
        </div>
      </section>

      {/* Video Section */}
      <section className={classes.videoSection}>
        <div className={classes.container}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}} data-aos="fade-up">
            <Typography variant="h2" className={classes.sectionTitle}>
              Our Mission Videos
            </Typography>
            <Typography variant="h5" style={{color: '#7f8c8d', fontWeight: 300, marginTop: '1rem'}}>
              See our work in action around the world
            </Typography>
          </div>
          <div style={{
            maxWidth: 800, 
            margin: '0 auto',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: 20,
            padding: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
          }}>
            <Caro2 />
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className={classes.gallerySection}>
        <div className={classes.container}>
          <div style={{textAlign: 'center', marginBottom: '4rem'}} data-aos="fade-up">
            <Typography variant="h2" className={classes.galleryTitle}>
              Our Global Impact
            </Typography>
            <Typography variant="h5" style={{color: '#7f8c8d', fontWeight: 300, marginTop: '1rem'}}>
              Our borders are extended throughout the World
            </Typography>
          </div>
          
          <div style={{
            background: 'rgba(255,255,255,0.05)',
            borderRadius: 20,
            padding: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            marginBottom: '3rem',
          }}>
  <Caroo data-aos="fade-up"/>
     </div>
          
          <div style={{
            textAlign: 'center',
            background: 'linear-gradient(135deg, #61DAFB 0%, #4A90E2 50%, #2C3E50 100%)',
            borderRadius: 20,
            padding: '40px',
            boxShadow: '0 20px 40px rgba(97, 218, 251, 0.2)',
          }} data-aos="fade-up">
            <Typography variant="h4" style={{color: 'white', fontWeight: 700, marginBottom: '1rem'}}>
              🌍 Global Outreach
            </Typography>
            <Typography variant="body1" style={{color: 'rgba(255,255,255,0.9)', marginBottom: '2rem'}}>
              We've made an impact across the globe
            </Typography>
            <img 
              src={imager} 
              width="100%" 
              style={{
                maxWidth: 800, 
                borderRadius: 12, 
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                border: '3px solid rgba(255,255,255,0.2)',
              }} 
            />
    </div>
        </div>
      </section>

      {/* Services Section */}
      <section className={classes.servicesSection}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} style={{color: 'white'}} data-aos="fade-up">
            What We Do
          </Typography>
          
          <Grid container spacing={4} style={{marginTop: 40}}>
            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="100">
              <div className={classes.serviceCard}>
                <img src={Community} className={classes.serviceIcon} alt="Community Outreach" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Community Outreach
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  This program is based on the Gospel of Jesus, Matthew 25: 42, 43 & 45 For I was hungry and you gave me no food, I was thirsty and you gave me no drink.
                </Typography>
              </div>
         </Grid> 

            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="200">
              <div className={classes.serviceCard}>
                <img src={Evangelism} className={classes.serviceIcon} alt="Evangelism" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Evangelism
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  Go ye therefore, and make disciples of All Nations, baptizing them in the name of the Father and of the Son and the Holy Spirit. Matthew 28:18-20
                </Typography>
              </div>
         </Grid> 

            <Grid item xs={12} md={4} data-aos="fade-up" data-aos-delay="300">
              <div className={classes.serviceCard}>
                <img src={Medical} className={classes.serviceIcon} alt="Health and Medical Outreach" />
                <Typography variant="h5" className={classes.serviceTitle}>
          Health and Medical Outreach
          </Typography>
                <Typography variant="body1" className={classes.serviceText}>
                  We promote the 8 Bible Secrets for a longer and stronger life for an Amazing Health Benefits when we use The Newstart Lifestyle
                </Typography>
              </div>
         </Grid> 
        </Grid> 
    </div>
      </section>

      {/* Map Section */}
      <section className={classes.mapSection}>
        <div className={classes.container}>
          <div className={classes.mapContainer}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3104.8484336332685!2d-76.81632558464938!3d38.90458117956952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7eab2795cc2e9%3A0x3b7e3088d8779114!2s1011%20Winged%20Foot%20Dr%2C%20Bowie%2C%20MD%2020721%2C%20USA!5e0!3m2!1sen!2sgh!4v1606680803222!5m2!1sen!2sgh" 
              width="100%" 
              height="400" 
              style={{border:0}} 
              title="location" 
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
    return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        <Typography variant="h3" className={classes.heroSubtitle} data-aos="fade-up">
          {props.item.description}
        </Typography>
            {props.item.name} 
        <div style={{marginTop: '2rem'}} data-aos="fade-up" data-aos-delay="300">
          <Button 
            variant="contained" 
            className={classes.heroButton}
            component={Link}
            to="/donate"
          >
            Support Our Mission
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Example;


